module.exports = __webpack_public_path__ + "img/pvh-24.6d8f0719.png";